<script lang="ts">
	import type { Solution } from "@core/schema/Solution.js";
	import { getServicesSolutionsDetailPath } from "@core/schema/paths/getServicesSolutionsDetailPath.js";
	import { findImageInContentBlocks } from "@core/schema/utils/findImageInContentBlocks.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import StructuredData from "./common/StructuredData.svelte";

	const { WEB_URL, FILE_BUCKET_URL_MAP } = getGlobalSettings();
	const { tenant } = getGlobalTemplateProps();
	const { solution }: { solution: Solution } = $props();

	const image = $derived(findImageInContentBlocks(solution.content));
</script>

<StructuredData
	data={{
		"@type": "Service",
		name: solution.name,
		description: solution.description,
		image: image && `${FILE_BUCKET_URL_MAP[image.bucket]}/${image.path}`,
		url: `${WEB_URL}${getServicesSolutionsDetailPath(tenant, solution)}`,
		provider: {
			"@type": "Organization",
			name: "Commarec",
			url: WEB_URL,
		},
		areaServed: {
			"@type": "Country",
			name: "Czech Republic",
		},
	}}
/>
